export type QueuedAction = {
	id: string;
	execute: () => Promise<unknown>;
	optimistic?: (() => (() => void) | null) | null;
	rollback?: (() => void) | null;
	toast?: {
		loading?: string;
		success?: string;
		error?: string | ((err: unknown) => string);
	};
	onSuccess?: () => void | Promise<void>;
	onError?: (err?: unknown) => void | Promise<void>;
};

/** Carries a committed mutation result through a later composite-operation failure. */
export class EntryMutationOutcomeError extends Error {
	readonly committedResult?: unknown;
	readonly exportedEntryGroupIds: string[];

	constructor(
		message: string,
		options?: { committedResult?: unknown; exportedEntryGroupIds?: string[] },
	) {
		super(message);
		this.name = "EntryMutationOutcomeError";
		this.committedResult = options?.committedResult;
		this.exportedEntryGroupIds = options?.exportedEntryGroupIds ?? [];
	}
}

export function createAction(action: Omit<QueuedAction, "id">): QueuedAction {
	return {
		...action,
		id: crypto.randomUUID(),
	};
}
